import { Component, OnInit } from '@angular/core';

@Component({ selector: 'app-placements', templateUrl: './placements.component.html', styleUrls: ['./placements.component.scss'] })
export class PlacementsComponent implements OnInit { constructor() { } ngOnInit(): void { } }
